<template>
  <div class="sets-and-groups-page" v-loading="loading">
    <el-radio-group v-model="activeTab" @input="handleTabChange">
      <el-radio-button label="sets">药品集合</el-radio-button>
      <el-radio-button label="groups">集合分组</el-radio-button>
    </el-radio-group>
    <template v-if="activeTab === 'sets'">
      <el-form class="search-form" :model="setSearchForm" inline size="small" label-width="80px">
        <el-form-item label="spuid">
          <el-input v-model.trim="setSearchForm.spuId" clearable placeholder="请输入spuid" />
        </el-form-item>
        <el-form-item label="集合名称">
          <el-input v-model.trim="setSearchForm.setName" clearable placeholder="请输入集合名称" />
        </el-form-item>
        <el-form-item label="分组名称">
          <el-input v-model.trim="setSearchForm.groupName" clearable placeholder="请输入分组名称" />
        </el-form-item>
        <el-form-item label="一级分类">
          <el-select v-model="setSearchForm.category" clearable placeholder="请选择">
            <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否设置分组" label-width="104px">
          <el-select v-model="setSearchForm.hasGroup" clearable placeholder="请选择">
            <el-option label="是" value="1" />
            <el-option label="否" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSetSearch">查询</el-button>
          <el-button @click="handleSetReset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table key="sets-table" ref="setTable" class="data-table" :data="setList" border :height="tableHeight">
        <el-table-column prop="spuId" label="spuid" width="100" align="center" />
        <el-table-column prop="spuName" label="集合名称" min-width="180" align="center" />
        <el-table-column prop="firstCategory" label="一级分类" min-width="140" align="center">
          <template slot-scope="scope">
            {{categoryOptions.find(item => item.value === scope.row.firstCategory) ? categoryOptions.find(item =>
              item.value === scope.row.firstCategory).label : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="商品数量" min-width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="openGoodsDetail(scope.row)">{{ scope.row.goodsCount || 0 }} 明细</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单位" width="100" align="center" />
        <el-table-column label="分组名称" min-width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.groupName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <div slot="default" slot-scope="scope">
            <el-button size="mini" :disabled="scope.row.firstCategory != 1 || ![0, -1].includes(deptId)" type="primary"
              @click="openGroupDialog(scope.row)">选择分组</el-button>
          </div>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :current-page="setPage.pageNum"
          :page-size="setPage.pageSize" :total="setPage.total" @current-change="handleSetPageChange" />
      </div>
    </template>

    <template v-else>
      <el-form class="search-form group-search-form" :model="groupSearchForm" inline size="small" label-width="40px">
        <el-form-item label="ID">
          <el-input v-model.trim="groupSearchForm.groupId" clearable placeholder="请输入分组ID" />
        </el-form-item>
        <el-form-item label="分组名称" label-width="80px">
          <el-input v-model.trim="groupSearchForm.groupName" clearable placeholder="请输入分组名称" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleGroupSearch">查询</el-button>
          <el-button @click="handleGroupReset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="group-toolbar">
        <el-button type="primary" size="small" :disabled="![0, -1].includes(deptId)"
          @click="openEditGroupDialog()">+新增分组</el-button>
      </div>
      <el-table key="groups-table" ref="groupTable" class="data-table group-data-table" :data="groupList" border
        :height="tableHeight">
        <el-table-column prop="groupId" label="ID" width="100" align="center" />
        <el-table-column prop="groupName" label="分组名称" min-width="180" align="center" />
        <el-table-column label="集合数量" width="120" align="center">
          <template slot-scope="scope">
            {{ getGroupMemberCount(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="180" align="center" />
        <el-table-column label="操作" min-width="190" align="center">
          <div slot="default" slot-scope="scope" class="group-actions">
            <el-button size="mini" :disabled="![0, -1].includes(deptId)" type="primary"
              @click="openEditGroupDialog(scope.row)">编辑</el-button>
            <el-button size="mini" :disabled="![0, -1].includes(deptId)" type="danger"
              @click="openDeleteGroupDialog(scope.row)">删除</el-button>
          </div>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :current-page="groupPage.pageNum"
          :page-size="groupPage.pageSize" :total="groupPage.total" @current-change="handleGroupPageChange" />
      </div>
    </template>

    <el-dialog title="选择分组" :visible.sync="groupDialogVisible" width="520px" custom-class="sets-dialog">
      <el-form :model="groupForm" label-width="90px" size="small">
        <el-form-item label="集合名称：">
          <span>{{ groupForm.setName }}</span>
        </el-form-item>
        <el-form-item label="选择分组">
          <el-select v-model="groupForm.groupId" clearable placeholder="请选择" class="dialog-select" filterable remote reserve-keyword  :remote-method="loadGroupOptions">
            <el-option v-for="item in groupOptions" :key="item.groupId" :label="item.groupName" :value="item.groupId"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="groupDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveSetGroup">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="集合商品明细" :visible.sync="goodsDetailVisible" width="560px" custom-class="sets-dialog">
      <div class="detail-title">集合名称： {{ goodsDetail.setName }}</div>
      <el-table v-loading="goodsDetailLoading" :data="goodsDetail.goodsList" border
        :cell-style="{ borderColor: '#333333' }"
        :header-cell-style="{ background: '#f7f8fa', borderColor: '#333333', color: '#333333' }">
        <el-table-column prop="articleNo" label="货号" width="120" align="center" />
        <el-table-column prop="drugKindName" label="商品名称" min-width="140" align="center" />
        <el-table-column prop="manufacturer" label="厂家" min-width="220" align="center" />
      </el-table>
      <div class="detail-pagination-wrap">
        <el-pagination small background layout="prev, pager, next" :current-page="goodsDetail.pageNum"
          :page-size="goodsDetail.pageSize" :total="goodsDetail.total" @current-change="handleGoodsPageChange" />
      </div>
    </el-dialog>

    <el-dialog :title="groupEditForm.groupId ? '编辑分组' : '新增分组'" :visible.sync="editGroupDialogVisible" width="360px"
      custom-class="group-edit-dialog">
      <el-form ref="groupEditForm" :model="groupEditForm" :rules="groupRules" label-width="82px" size="small">
        <el-form-item label="分组名称" prop="groupName">
          <el-input v-model.trim="groupEditForm.groupName" clearable placeholder="请输入" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editGroupDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveGroup">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="deleteGroupDialogVisible" width="420px" custom-class="delete-group-dialog">
      <div class="delete-tip">删除分组后组内商品关联关系将自动失效<br>确定删除该分组？</div>
      <span slot="footer">
        <el-button @click="deleteGroupDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="confirmDeleteGroup">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addDrugSpuGroup,
  bindDrugSpuGroup,
  deleteDrugSpuGroup,
  editDrugSpuGroup,
  queryDrugSpuGroupFirstCategoryOptions,
  queryDrugSpuGroupGoods,
  queryDrugSpuGroupOptions,
  queryDrugSpuGroups,
  queryDrugSpuGroupSpus,
  unbindDrugSpuGroup
} from '@/api/drug';

const getEmptySetSearchForm = () => ({
  spuId: '',
  setName: '',
  groupName: '',
  category: '',
  hasGroup: ''
});

const getEmptyGroupSearchForm = () => ({
  groupId: '',
  groupName: ''
});

const getEmptyGroupForm = () => ({
  spuId: '',
  setName: '',
  groupId: ''
});

const getEmptyGroupEditForm = () => ({
  groupId: '',
  groupName: ''
});

const getEmptyGoodsDetail = () => ({
  spuId: '',
  setName: '',
  goodsList: [],
  pageNum: 1,
  pageSize: 10,
  total: 0
});

export default {
  name: 'SetsAndGroups',
  data() {
    return {
      activeTab: 'sets',
      loading: false,
      saving: false,
      goodsDetailLoading: false,
      tableHeight: 560,
      setSearchForm: getEmptySetSearchForm(),
      groupSearchForm: getEmptyGroupSearchForm(),
      setPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      groupPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      groupDialogVisible: false,
      goodsDetailVisible: false,
      editGroupDialogVisible: false,
      deleteGroupDialogVisible: false,
      deletingGroup: null,
      groupForm: getEmptyGroupForm(),
      goodsDetail: getEmptyGoodsDetail(),
      groupEditForm: getEmptyGroupEditForm(),
      groupRules: {
        groupName: [{ required: true, message: '请输入分组名称', trigger: 'blur' }]
      },
      categoryOptions: [],
      groupOptions: [],
      groupList: [],
      setList: [],
      deptId: ''
    };
  },
  created() {
    this.deptId = this.$session.get('deptId');
    this.loadSetList();
    this.loadCategoryOptions();
    this.loadGroupOptions();
  },
  mounted() {
    this.updateTableHeight();
    this.$nextTick(this.layoutActiveTable);
    window.addEventListener('resize', this.updateTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTableHeight);
  },
  methods: {
    updateTableHeight() {
      this.tableHeight = Math.max(300, document.documentElement.clientHeight - 280);
      this.$nextTick(this.layoutActiveTable);
    },
    layoutActiveTable() {
      const table = this.activeTab === 'sets' ? this.$refs.setTable : this.$refs.groupTable;
      if (table && typeof table.doLayout === 'function') table.doLayout();
    },
    isSuccess(res) {
      return res && Number(res.code) === 200;
    },
    hasValue(value) {
      return value !== '' && value !== null && value !== undefined;
    },
    getGroupMemberCount(row) {
      if (!row) return 0;
      const count = [
        row.memberCount,
        row.spuCount,
        row.setCount,
        row.collectionCount,
        row.memberNum,
        row.spuNum,
        row.setNum,
        row.count
      ].find(value => this.hasValue(value));
      const number = Number(count);
      return Number.isFinite(number) ? number : 0;
    },
    toNumber(value) {
      if (!this.hasValue(value)) return null;
      const number = Number(value);
      return Number.isFinite(number) ? number : null;
    },
    showRequestError(error, message) {
      if (error) {
        this.$message.error(message || '请求失败，请稍后重试');
      }
    },
    async loadCategoryOptions() {
      try {
        const res = await queryDrugSpuGroupFirstCategoryOptions();
        this.categoryOptions = this.isSuccess(res) && Array.isArray(res.data) ? res.data : [];
      } catch (error) {
        this.categoryOptions = [];
        this.showRequestError(error, '一级分类加载失败');
      }
    },
    async loadGroupOptions(keyword) {
      try {
        const res = await queryDrugSpuGroupOptions({ limit: 1000, keyword: keyword || '' });
        this.groupOptions = this.isSuccess(res) && Array.isArray(res.data) ? res.data : [];
      } catch (error) {
        this.groupOptions = [];
        this.showRequestError(error, '分组选项加载失败');
      }
    },
    async loadSetList() {
      this.loading = true;
      const params = {
        pageNum: this.setPage.pageNum,
        pageSize: this.setPage.pageSize
      };
      const spuId = this.toNumber(this.setSearchForm.spuId);
      if (this.hasValue(this.setSearchForm.spuId) && spuId !== null) params.spuId = spuId;
      if (this.hasValue(this.setSearchForm.setName)) params.spuName = this.setSearchForm.setName;
      if (this.hasValue(this.setSearchForm.groupName)) params.groupName = this.setSearchForm.groupName;
      if (this.hasValue(this.setSearchForm.category)) params.firstCategory = this.setSearchForm.category;
      if (this.hasValue(this.setSearchForm.hasGroup)) params.grouped = this.setSearchForm.hasGroup;
      try {
        const res = await queryDrugSpuGroupSpus(params);
        if (this.isSuccess(res)) {
          this.setList = Array.isArray(res.rows) ? res.rows : [];
          this.setPage.total = Number(res.total) || 0;
          this.$nextTick(this.layoutActiveTable);
        }
      } catch (error) {
        this.setList = [];
        this.setPage.total = 0;
        this.showRequestError(error, '药品集合加载失败');
      } finally {
        this.loading = false;
      }
    },
    async loadGroupList() {
      this.loading = true;
      const params = {
        pageNum: this.groupPage.pageNum,
        pageSize: this.groupPage.pageSize
      };
      const groupId = this.toNumber(this.groupSearchForm.groupId);
      if (this.hasValue(this.groupSearchForm.groupId) && groupId !== null) params.groupId = groupId;
      if (this.hasValue(this.groupSearchForm.groupName)) params.groupName = this.groupSearchForm.groupName;
      try {
        const res = await queryDrugSpuGroups(params);
        if (this.isSuccess(res)) {
          this.groupList = Array.isArray(res.rows) ? res.rows : [];
          this.groupPage.total = Number(res.total) || 0;
          this.$nextTick(this.layoutActiveTable);
        }
      } catch (error) {
        this.groupList = [];
        this.groupPage.total = 0;
        this.showRequestError(error, '集合分组加载失败');
      } finally {
        this.loading = false;
      }
    },
    async loadGoodsDetail() {
      const spuId = this.toNumber(this.goodsDetail.spuId);
      if (spuId === null) return;
      this.goodsDetailLoading = true;
      try {
        const res = await queryDrugSpuGroupGoods({
          spuId,
          pageNum: this.goodsDetail.pageNum,
          pageSize: this.goodsDetail.pageSize
        });
        if (this.isSuccess(res)) {
          this.goodsDetail.goodsList = Array.isArray(res.data) ? res.data : [];
          this.goodsDetail.total = Number(res.total) || 0;
        }
      } catch (error) {
        this.goodsDetail.goodsList = [];
        this.goodsDetail.total = 0;
        this.showRequestError(error, '集合商品明细加载失败');
      } finally {
        this.goodsDetailLoading = false;
      }
    },
    handleTabChange() {
      if (this.activeTab === 'sets') {
        this.setPage.pageNum = 1;
        this.loadSetList();
      } else {
        this.groupPage.pageNum = 1;
        this.loadGroupList();
      }
      this.loadGroupOptions();
      this.$nextTick(this.layoutActiveTable);
    },
    handleSetSearch() {
      this.setPage.pageNum = 1;
      this.loadSetList();
    },
    handleSetReset() {
      this.setSearchForm = getEmptySetSearchForm();
      this.setPage.pageNum = 1;
      this.loadSetList();
    },
    handleSetPageChange(pageNum) {
      this.setPage.pageNum = pageNum;
      this.loadSetList();
    },
    handleGroupSearch() {
      this.groupPage.pageNum = 1;
      this.loadGroupList();
    },
    handleGroupReset() {
      this.groupSearchForm = getEmptyGroupSearchForm();
      this.groupPage.pageNum = 1;
      this.loadGroupList();
    },
    handleGroupPageChange(pageNum) {
      this.groupPage.pageNum = pageNum;
      this.loadGroupList();
    },
    openGroupDialog(row) {
      this.groupForm = {
        spuId: row.spuId,
        setName: row.spuName,
        groupId: this.hasValue(row.groupId) ? row.groupId : ''
      };
      this.groupDialogVisible = true;
      this.loadGroupOptions();
    },
    async saveSetGroup() {
      const spuId = this.toNumber(this.groupForm.spuId);
      if (spuId === null) return;
      this.saving = true;
      const params = { spuId };
      let request;
      if (this.hasValue(this.groupForm.groupId)) {
        params.groupId = Number(this.groupForm.groupId);
        request = bindDrugSpuGroup(params);
      } else {
        request = unbindDrugSpuGroup(params);
      }
      try {
        const res = await request;
        if (this.isSuccess(res)) {
          this.groupDialogVisible = false;
          this.$message.success('保存成功');
          await this.loadSetList();
          this.loadGroupOptions();
        }
      } catch (error) {
        this.showRequestError(error, '分组保存失败');
      } finally {
        this.saving = false;
      }
    },
    openGoodsDetail(row) {
      this.goodsDetail = {
        ...getEmptyGoodsDetail(),
        spuId: row.spuId,
        setName: row.spuName
      };
      this.goodsDetailVisible = true;
      this.loadGoodsDetail();
    },
    handleGoodsPageChange(pageNum) {
      this.goodsDetail.pageNum = pageNum;
      this.loadGoodsDetail();
    },
    openEditGroupDialog(row) {
      this.groupEditForm = row
        ? { groupId: row.groupId, groupName: row.groupName }
        : getEmptyGroupEditForm();
      this.editGroupDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.groupEditForm) this.$refs.groupEditForm.clearValidate();
      });
    },
    saveGroup() {
      this.$refs.groupEditForm.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        const isEdit = this.hasValue(this.groupEditForm.groupId);
        const params = { groupName: this.groupEditForm.groupName };
        if (isEdit) params.groupId = Number(this.groupEditForm.groupId);
        try {
          const res = await (isEdit ? editDrugSpuGroup(params) : addDrugSpuGroup(params));
          if (this.isSuccess(res)) {
            this.editGroupDialogVisible = false;
            this.$message.success('保存成功');
            await this.loadGroupList();
            this.loadGroupOptions();
          }
        } catch (error) {
          this.showRequestError(error, '分组保存失败');
        } finally {
          this.saving = false;
        }
      });
    },
    openDeleteGroupDialog(row) {
      this.deletingGroup = row;
      this.deleteGroupDialogVisible = true;
    },
    async confirmDeleteGroup() {
      if (!this.deletingGroup || !this.hasValue(this.deletingGroup.groupId)) return;
      this.saving = true;
      try {
        const res = await deleteDrugSpuGroup({ groupId: Number(this.deletingGroup.groupId) });
        if (this.isSuccess(res)) {
          this.deleteGroupDialogVisible = false;
          this.$message.success('删除成功');
          this.deletingGroup = null;
          if (this.groupList.length === 1 && this.groupPage.pageNum > 1) this.groupPage.pageNum -= 1;
          await this.loadGroupList();
          this.loadGroupOptions();
          if (this.activeTab === 'sets') this.loadSetList();
        }
      } catch (error) {
        this.showRequestError(error, '分组删除失败');
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.sets-and-groups-page {
  height: 100%;
  box-sizing: border-box;
  padding: 16px 18px;
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .search-form {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-bottom: 8px;
    margin-top: 16px;

    /deep/ .el-form-item {
      margin-right: 24px;
      margin-bottom: 12px;
    }

    /deep/ .el-input,
    /deep/ .el-select {
      width: 154px;
    }
  }

  .group-search-form {
    margin-bottom: 2px;

    /deep/ .el-form-item {
      margin-right: 44px;
    }

    /deep/ .el-input {
      width: 190px;
    }
  }

  .data-table {
    width: 100%;
    min-width: 0;
  }

  .group-data-table {
    flex-shrink: 0;

    /deep/ .group-actions {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      white-space: nowrap;
    }

    /deep/ .group-actions .el-button {
      margin-left: 0;
    }
  }

  .pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }

  .group-toolbar {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 10px;
  }

  .dialog-select {
    width: 300px;
  }

  .detail-title {
    margin-bottom: 14px;
    color: #303133;
    font-size: 14px;
    font-weight: 600;
  }

  .detail-pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }

  .delete-tip {
    padding: 12px 10px 18px;
    color: #303133;
    line-height: 24px;
    text-align: center;
  }

  /deep/ .group-edit-dialog .el-dialog__body,
  /deep/ .delete-group-dialog .el-dialog__body {
    padding: 22px 24px;
  }

  /deep/ .group-edit-dialog .el-dialog__footer,
  /deep/ .delete-group-dialog .el-dialog__footer {
    padding: 8px 24px 24px;
  }

  /deep/ .group-edit-dialog .el-dialog__footer .el-button,
  /deep/ .delete-group-dialog .el-dialog__footer .el-button {
    min-width: 86px;
  }

  /deep/ .sets-dialog .el-dialog__header {
    padding: 22px 24px 12px;
  }

  /deep/ .sets-dialog .el-dialog__title {
    font-size: 20px;
    font-weight: 600;
    color: #1f2d3d;
  }

  /deep/ .sets-dialog .el-dialog__body {
    padding: 20px 32px 26px;
  }

  /deep/ .sets-dialog .el-dialog__footer {
    padding: 10px 32px 28px;
  }

  /deep/ .sets-dialog .el-dialog__footer .el-button {
    min-width: 104px;
  }
}
</style>